import { Suspense } from "react"
import {
	finishHidePopup,
	getPopupRenderer,
	usePopup,
	usePopupOpen,
} from "@/entities/bottom-popup"
import { OverlayHost } from "@/shared/ui/overlay"

function BottomPopup() {
	const open = usePopupOpen()
	const popup = usePopup()
	const Renderer = popup ? getPopupRenderer(popup.type) : undefined

	return (
		<Suspense fallback={null}>
			<OverlayHost open={open} onExitComplete={finishHidePopup}>
				{Renderer ? <Renderer /> : null}
			</OverlayHost>
		</Suspense>
	)
}

export { BottomPopup }
